import ApiService from "../ApiService";

const locationService = {
    getStatesByCountry(countryId) {
        countryId = countryId || 1;
        return ApiService.get(`/state/country/${countryId}`);
    },

    getStatesWithDeliveryPoint(countryId) {
        countryId = countryId || 1;
        return ApiService.get(`/state/country/${countryId}/withDeliveryPoint`);
    },

    getCitiesByState(stateId) {
        stateId = stateId || 0;
        return ApiService.get(`/city/state/${stateId}`);
    },
    getCitiesWithDeliveryPoint(data) {
        return ApiService.post(`/city/state/withDeliveryPoint`, data);
    },
    getStatesByProvider(countryId, type, providerId) {
        countryId = countryId || 1;
        return ApiService.get(`/state/byCountryScheduleRanges/${countryId}/${type}/${providerId}`);
    },

    getCitiesByProvider(stateId, type, providerId) {
        stateId = stateId || 0;
        type = type || "";
        providerId = providerId || 0;
        return ApiService.get(`/city/stateScheduleRanges/${stateId}/${type}/${providerId}`);
    },

    getBranchesByCityAndProvider(cityId, providerId) {
        cityId = cityId || 0;
        providerId = providerId || 0;
        return ApiService.get(`/branch/city/${cityId}/provider/${providerId}`);
    },

    getBranchesByProvider(providerId) {
        providerId = providerId || 0;
        return ApiService.get(`/branch/provider/${providerId}`);
    },

    getBranchesByProviderPolicy(providerId) {
        providerId = providerId || 0;
        return ApiService.get(`/policy-branch/provider/${providerId}`);
    },

    getBranchCitiesByBranch(branchId) {
        branchId = branchId || 0;
        return ApiService.get(`/branch-city/branch/${branchId}`);
    },

    getBranchCitiesByBranchPolicy(branchId) {
        branchId = branchId || 0;
        return ApiService.get(`/policy-branch-city/branch/${branchId}`);
    },

    getBranchesByCityProviderAndType(cityId, providerId, type, branch) {
        cityId = cityId || 0;
        providerId = providerId || 0;
        type = type || 'none';
        branch = branch || 0
        return ApiService.get(`/branch/city/${cityId}/provider/${providerId}/type/${type}`);
    },
    getBranchesByCityProviderAndTypePolicy(cityId, providerId, type, branch) {
        cityId = cityId || 0;
        providerId = providerId || 0;
        type = type || "none";
        branch = branch || 0;
        return ApiService.get(`/policy-branch/city/${cityId}/provider/${providerId}/type/${type}`);
    },

    getBranchesForUnifiedPharmacy(cityId) {
        cityId = cityId || 0;
        return ApiService.get(`/branch/city/${cityId}/unified-pharmacy`);
    },

    getScheduleRangesByBranch(branchId) {
        branchId = branchId || 0;
        return ApiService.get(`/provider-schedule-range/branch/${branchId}`);
    },
    getScheduleRangesByBranchPolicy(branchId) {
        branchId = branchId || 0;
        return ApiService.get(`/policy-schedule-range/branch/${branchId}`);
    },

    getScheduleRangesByPolicyBranch(branchId) {
        branchId = branchId || 0;
        return ApiService.get(`/policy-branch/${branchId}`);
    },
};

export default locationService;